import type { ReactNode } from 'react';

type Tono = 'info' | 'alerta' | 'error' | 'exito';

interface Props {
  tono?: Tono;
  children: ReactNode;
}

const TONOS: Record<Tono, string> = {
  info: 'border-navy/10 bg-navy/5 text-navy',
  alerta: 'border-oro/30 bg-oro/10 text-[#7a5a13]',
  error: 'border-red-200 bg-red-50 text-red-700',
  exito: 'border-emerald-200 bg-emerald-50 text-emerald-700',
};

export function Callout({ tono = 'info', children }: Props) {
  return (
    <div
      className={`rounded-2xl border px-4 py-3 text-sm leading-relaxed ${TONOS[tono]}`}
      role={tono === 'error' || tono === 'alerta' ? 'alert' : undefined}
    >
      {children}
    </div>
  );
}
